import PlateAppearanceResult from "../../enums/PlateAppearanceResult.js";

// @see https://www.mlb.com/glossary/standard-stats/on-base-percentage
// @see https://en.wikipedia.org/wiki/On-base_percentage
// @see https://en.wikipedia.org/wiki/Times_on_base
// Times on base include hits, walks and hit-by-pitches, but do not include errors, times reached on a fielder's choice or a dropped third strike. (Separately, sacrifice bunts are removed from the equation entirely, because it is rarely a hitter's decision to sacrifice himself, but rather a manager's choice as part of an in-game strategy.)
// OBP does not credit the batter for reaching base due to fielding error, fielder's choice, dropped/uncaught third strike, fielder's obstruction, or catcher's interference.
const classifiesAsTimeOnBase = function(paResult) {
    switch (paResult) {
        // Base hits
        case PlateAppearanceResult.Double.key:
        case PlateAppearanceResult.GroundRuleDouble.key:
        case PlateAppearanceResult.HomeRun.key:
        case PlateAppearanceResult.InsideTheParkHomeRun.key:
        case PlateAppearanceResult.Single.key:
        case PlateAppearanceResult.Triple.key:
        // walks
        case PlateAppearanceResult.Walk.key:
        case PlateAppearanceResult.IntentionalWalk.key:
        // batter safe - other
        case PlateAppearanceResult.HitByPitch.key:
        //case PlateAppearanceResult.Unidentified.key:
            return true;

        default:
            return false;
    }
};

export default classifiesAsTimeOnBase;